module.exports = __webpack_public_path__ + "img/tou.34ea02da.png";